import { Component, OnInit, Injector, Input, ChangeDetectionStrategy } from "@angular/core";
import { GenericBasicGUI } from "src/model/class/component classes/generic-basic-gui";
import { ScenariosService } from "src/service/scenarios.service";
import { Scenario } from "src/model/class/general classes/scenario";
import { AlertService } from "src/service/alert.service";
import { environment } from "src/environments/environment";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { HAlign } from "src/model/enum/enumCustomInterface";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";
import { LogLevel } from "src/components/shared-components/enum/enumLog";

@Component({
    selector: "app-scenario-button",
    templateUrl: "./scenario-button.component.html",
    styleUrls: ["./scenario-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScenarioButtonComponent extends GenericBasicGUI implements OnInit {
  _logContext: string = "Scenario-button.component";

  private timeoutMousDown: ReturnType<typeof setTimeout>;
  private _listScenario: Array<Scenario> = new Array<Scenario>();

  public styles = {
    "font-family": "Arial",
    // tslint:disable-next-line: object-literal-key-quotes
    color: "#000000",
    "font-size": "15px",
    "font-style": "normal", // italic
    "font-weight": "normal", // bol
    "font-decorator": "none", // underline
    "background-image": "",
    overflow: "hidden",
  };

  public stylesChild = {};
  

  /**
   * Giorgia -
   * @param injector The injector param is used by the parent classes to inject the services that they needed:
   * using this trick if the parent classes needed some specific service I don't need to inject them here
   * but I can do the injection in the specific class.
   */
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.loadListScenario();
    /** Reassign hAlignment value if not passed as component parameter */
    if (!this.hAlignment) {
      this.hAlignment = HAlign.CENTER;
    }

    [this.styles, this.stylesChild] = super.HandleProperties(
      this.styles,
      this.stylesChild
    );

    if (!this.ShowingInDesktopVersion) {
      this.styles["margin"] = this.assignComponentMarginByAlignment(
        this.hAlignment.toString()
      );
    }
  }

  ngOnDestroy() {
    this.onDestroyChildren();
  }


  /**
* GF: handle the event "mouseDown"
* if the button is keep pressed (not just a rapid touch), the event MouseUp and Click is not sended.
* For this reason if the image is keep pressed after 500 ms is simulated the mouseUp event and sended the click event
* 
* IF the "ion-content" element in which the button is contained is currently scrolling, NO ACTION IS EXECUTED.
*/
  public MouseDown() {
    if (!this.platform.is("ios") && !this.platform.is("android") && !this.isContainingListScrolling) {
      this.loggerService.log(
        LogLevel.LOG_INFO,
        this._logContext,
        this._logContext,
        "MouseDown()",
        "START"
      );

      this.handleStartPressedAction();
    }
  }

  /**
 * GF: handle the touch from device
 * if the button is keep pressed (not just a rapid touch), the event MouseUp and Click is not sended.
 * For this reason if the image is keep pressed after 500 ms is simulated the mouseUp event and sended the click event
 * 
 * IF the "ion-content" element in which the button is contained is currently scrolling, NO ACTION IS EXECUTED.
 */
  public TouchStart() {
    if (!this.isContainingListScrolling) {

      this.loggerService.log(
        LogLevel.LOG_INFO,
        this._logContext,
        this._logContext,
        "TouchStart()",
        "START"
      );
      this.handleStartPressedAction();
    }
  }


  /**
 * Touch end event handler on device
 * If click action is different to "No action" set pressed image.
 * 
 * IF the "ion-content" element in which the button is contained is currently scrolling, NO ACTION IS EXECUTED. ALSO, the associated image is un-pressed.
 */
  public MouseUp() {
    if (!this.platform.is("ios") && !this.platform.is("android")) {
      if (!this.isContainingListScrolling) {
        this.loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          this._logContext,
          "MouseUp()",
          "NOT SCROLLING"
        );

        this.handleEndPressedAction();
      } else {
        this.SetPressedImage(false);
        this.cssCustomComponetClass = "";
      }
    }
  }

  /**
 * Touch end event handler on device
 * If click action is different to "No action" set pressed image.
 * 
 * IF the "ion-content" element in which the button is contained is currently scrolling, NO ACTION IS EXECUTED. ALSO, the associated image is un-pressed.
 */
  public TouchEnd(): void {
    if (!this.isContainingListScrolling) {
      this.handleEndPressedAction();
    } else {
      this.cssCustomComponetClass = "";

      this.SetPressedImage(false);
    }
  }



  public Click() { }

  /**
 * Handle start pressed action
 */
  private handleStartPressedAction(): void {
    this.cssCustomComponetClass = "clicked-supervision-button-element";

    this.SetPressedImage(true);
  }

  /**
 * Handle end presseed action
 */
  private handleEndPressedAction(): void {
    this.cssCustomComponetClass = "";

    this.handleScenarioExecutionClick();
    this.SetPressedImage(false);
  }


  /**
   * Handle scenario execution page
   */
  private async handleScenarioExecutionClick(): Promise<void> {
    if (this.isScenarioIdPropertySet()) {
      const foundedScenario = this._listScenario.find(
        (scenario: Scenario) =>
          scenario.id === Number(this.ComponentAPI.properties["Scenario"])
      );

      if (foundedScenario) {
        const canExecuteCommand: boolean =
          await this.handleOpenPopupRequestConfirmCommandExecution();

        if (canExecuteCommand) {
          this.SendCommand(this.ComponentAPI.properties["ClickAction"]);
        }
      } else {
        this.presentScenarioNotExistingAlert();
      }
    }
  }

  /**
   * Check if scenario id is correctly related to button
   *
   * @returns boolean who express that property "Scenario" is correctly sert
   */
  private isScenarioIdPropertySet(): boolean {
    return (
      this.ComponentAPI.properties["Scenario"] &&
      parseInt(this.ComponentAPI.properties["Scenario"]) > 0
    );
  }

  /**
   * Load scenario list from service
   */
  private loadListScenario(): void {
    this.scenarioService.scenarioList.subscribe(
      (listScenario: Array<Scenario>) => {
        this._listScenario = listScenario || [];
      }
    );
  }

  /**
   * Handle popup presentation for scenario not existing alert
   */
  private presentScenarioNotExistingAlert(): void {
    this.alertService.presentAlertOk(
      this.lblAttention,
      "",
      this.lblScenarioDeleted
    );

    //this.alertService.clearAlertOk();
  }

  protected setCurrentImage(urlImage: string, stretch: boolean) {
    if (!this.ShowingInDesktopVersion) {
      this.styles["width"] = "48px";
      this.styles["height"] = "48px";
      this.styles["background-size"] = "cover";
    }

    if (urlImage !== "") {
      this.styles["background-image"] = "url(" + urlImage + ")";
      if (stretch) {
        this.styles["background-size"] = "contain";
      } else {
        this.styles["background-size"] = "initial";
      }
      this.styles["background-position"] = "center";
      this.styles["background-repeat"] = "no-repeat";
    } else {
      this.styles["background"] =
        AppSettings.CUSTOM_INTERFACE_BUTTON_DEFAULT_BACKGROUND;
      this.styles["border"] =
        AppSettings.CUSTOM_INTERFACE_BUTTON_DEFAULT_BORDER;
    }
  }
}
